import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 17 18"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M16.407 17.61a.75.75 0 0 1-.658.39h-4.5a.75.75 0 0 1-.632-.348l-3.796-5.965-5.517 6.067a.75.75 0 0 1-1.11-1.008l5.791-6.375L.117 1.153A.75.75 0 0 1 .75 0h4.5a.75.75 0 0 1 .633.348l3.796 5.965L15.194.246a.75.75 0 0 1 1.11 1.008l-5.79 6.37 5.869 9.224a.75.75 0 0 1 .024.762"
    }, null, -1)
  ]))]))
}
export default { render: render }